import { persistAuthSession } from './auth-session.util';

/** Persist auth passed from the landing page via URL hash on cross-app redirect. */
export function consumeSessionHandoffFromHash(): void {
  if (typeof window === 'undefined') {
    return;
  }
  const hash = window.location.hash.replace(/^#/, '').trim();
  if (!hash) {
    return;
  }

  const params = new URLSearchParams(hash);
  const accessToken = params.get('accessToken')?.trim();
  if (!accessToken) {
    return;
  }

  persistAuthSession({
    accessToken,
    refreshToken: params.get('refreshToken')?.trim() || undefined,
    workspaceId: params.get('workspace_id')?.trim() || undefined,
    userId: params.get('id')?.trim() || undefined,
    role: params.get('role')?.trim() || undefined,
  });

  window.history.replaceState(
    null,
    '',
    `${window.location.pathname}${window.location.search}`,
  );
}
